// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-65d0be59]:root {\n  --width: 100px;\n}\n.el-table th.code-column[data-v-65d0be59],\n.el-table td.code-column[data-v-65d0be59] {\n  width: var(--width);\n}", ""]);
// Exports
module.exports = exports;
